import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "maskClass", "contentClass", "contentTransitionType", "className", "direction", "needBottomOffset", "translateZ", "maskTransitionTimeout", "contentTransitionTimeout"];
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls, componentWrapper } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import Masking from '../masking';
import { open } from './methods';
export * from './methods';
var Popup = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      maskClass = props.maskClass,
      contentClass = props.contentClass,
      contentTransitionType = props.contentTransitionType,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'bottom' : _props$direction,
      _props$needBottomOffs = props.needBottomOffset,
      needBottomOffset = _props$needBottomOffs === void 0 ? false : _props$needBottomOffs,
      _props$translateZ = props.translateZ,
      translateZ = _props$translateZ === void 0 ? false : _props$translateZ,
      _props$maskTransition = props.maskTransitionTimeout,
      maskTransitionTimeout = _props$maskTransition === void 0 ? {
    enter: 450,
    exit: 240
  } : _props$maskTransition,
      _props$contentTransit = props.contentTransitionTimeout,
      contentTransitionTimeout = _props$contentTransit === void 0 ? {
    enter: 450,
    exit: 240
  } : _props$contentTransit,
      restProps = _objectWithoutPropertiesLoose(props, _excluded);

  var maskingRef = useRef(null);
  useImperativeHandle(ref, function () {
    return maskingRef.current;
  });

  function renderPopup(_ref) {
    var prefixCls = _ref.prefixCls;
    var prefix = prefixCls + "-popup";
    return /*#__PURE__*/React.createElement(Masking, _extends({
      className: cls(prefix, className),
      ref: maskingRef,
      maskClass: cls(prefix + "-mask", {
        translateZ: translateZ
      }, maskClass),
      contentTransitionType: contentTransitionType || "slide-from-" + direction,
      contentClass: cls(prefix + "-content", direction, {
        'need-bottom-offset': needBottomOffset
      }, {
        translateZ: translateZ
      }, contentClass),
      maskTransitionTimeout: maskTransitionTimeout,
      contentTransitionTimeout: contentTransitionTimeout
    }, restProps), children);
  }

  return /*#__PURE__*/React.createElement(ContextLayout, null, renderPopup);
});
export function methodsGenerator(Comp) {
  return {
    /**
     * 打开弹出层
     * @param {PopupProps} config 配置
     * @returns {{ close: () => void; update: (newConfig: PopupProps) => void; }}
     */
    open: open(Comp)
  };
}
/**
 * 基于模态弹窗的的全屏菜单，支持各个方向。默认做了防滚动穿透处理，如果弹层内容中需要滚动，则需将滚动容器传入`getScrollContainer`属性以在未滚动到顶部或底部时释放滚动。
 * @type 反馈
 * @name 弹出层
 */

export default componentWrapper(Popup, methodsGenerator(Popup));